import React from "react";

const Message = () => {
  return (

    <div id="introduction" className="message-for-visitor">
      Dear visitors,
      <br />
      <br />
      <p>
        Welcome to my personal portfolio webpage! Here, you will find a
        collection of my work and experiences in web and app development. I've
        created this website as a way to showcase my skills, highlight my
        achievements, and provide insight into my professional journey. Please
        take some time to explore the various sections of my website. You'll
        find a brief overview of my background and experience, along with
        samples of my work in the portfolio section. If you have any questions
        or would like to discuss a potential collaboration, please don't
        hesitate to reach out via the contact form. Thank you for visiting and I
        hope you enjoy learning more about me and my work.
      </p>
      Sincerely,
      <br />
      <br />
      Chirag Gandherva
    </div>
  );
};

export default Message;
